<template>
  <v-card>
    <uploader
      ref="uploader"
      @file-success="onFileSuccess"
      :options="options"
      :auto-start="false"
      class="uploader-example"
      style="margin: 0px; background: rgba(0, 0, 0, 0.1); width: 100%; padding: 0px"
    >
      <v-toolbar color="primary">
        <span class="headline">Add Documents</span>
        <uploader-btn style="border: 0px" :single="true">
          <i aria-hidden="true" class="v-icon material-icons">library_add</i>
        </uploader-btn>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="hideDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex lg2>
            <v-subheader>Document Type: </v-subheader>
          </v-flex>
          <v-flex lg4>
            <v-select label="Please Select The Document Type" :items="listDocumentTypeOption()" v-model="documentType">
              <v-autocomplete></v-autocomplete>
            </v-select>
          </v-flex>
        </v-layout>
        <uploader-list></uploader-list>
      </v-card-text>
    </uploader>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click.native="upload">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { OriginationApi } from '@/api/pandaria'
import { Popup, DataType } from '@/util/index'
const popup = new Popup()
export default {
  name: 'add-document-dialog',
  props: {
    loanId: Number
  },
  data () {
    return {
      options: {
        target: '/gateway/platform-lmsapi/origination/loan-document/upload?loanId=' + this.loanId,
        singleFile: true,
        simultaneousUploads: 1,
        chunkSize: 1024 * 1024 * 20,
        initialPaused: true,
        forceChunkSize: false,
        autoStart: false,
        testChunks: false
      },
      documentTypeList: [{ text: 'Bank document', value: '2' }],
      documentType: null,
      uploaderInstance: null,
      fileDownloadUrl: null,
      documentName: null,
      documentSize: null
    }
  },
  mounted () {
    this.uploaderInstance = this.$refs.uploader.uploader
    const $this = this
    this.uploaderInstance.on('fileAdded', function (file, event) {
      if (file.size / (1024 * 1024) > 10) {
        popup.popupForWarning('The uploaded file size should not be larger than 10M', null, function () {
          $this.hideDialog()
        })
      }
    })
  },
  methods: {
    listDocumentTypeOption () {
      const documentTypeOption = []
      for (const item in DataType.DocumentTypeEnum) {
        documentTypeOption.push(DataType.DocumentTypeEnum[item])
      }
      return documentTypeOption
    },
    hideDialog () {
      this.fileDownloadUrl = null
      this.uploaderInstance.cancel()
      this.documentType = null
      this.$emit('hideDialog', 'ADD_DOCUMENT')
    },
    upload () {
      let isSaveDocument = true
      const $this = this
      if (this.uploaderInstance.files[0] === undefined) {
        isSaveDocument = false
        popup.popupForInfo('Please select a file and upload file.')
      } else {
        const currentFile = this.uploaderInstance.files[0]
        if (currentFile.paused || !currentFile.completed) {
          isSaveDocument = false
          popup.popupForInfo('File has not been uploaded or has been suspended. Click OK to continue operation and click Cancel to exit uploading',
            { showCancelButton: true }, null, function () {
              $this.hideDialog()
            })
        }
        if (this.documentType === null) {
          isSaveDocument = false
          popup.popupForInfo('Please select the document type', { showCancelButton: true }, null, function () {
            $this.hideDialog()
          })
        }
        if (isSaveDocument) {
          const request = {
            loanId: this.loanId,
            fileDownloadUrl: this.fileDownloadUrl,
            documentName: this.documentName,
            documentSize: this.documentSize,
            documentType: this.documentType
          }
          OriginationApi.addDocumentData(request, function () {
            popup.popupForSuccess('Add document success')
          },
          function () {
            popup.popupForError('Add document fail')
          }
          )
          $this.hideDialog()
        }
      }
    },
    onFileSuccess (rootFile, file, response) {
      const parse = JSON.parse(response)
      if (parse.code >= 1) {
        this.fileDownloadUrl = parse.data.fileDownloadUrl
        this.documentName = parse.data.documentName
        this.documentSize = parse.data.documentSize
      } else {
        popup.popupForError('File upload failed, please try again')
        file.cancel()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.uploader-example {
  width: 880px;
  padding: 15px;
  margin: 40px auto 0;
  font-size: 12px;
  background-color: white !important;
  min-height: 300px;
  .uploader-btn {
    margin-right: 4px;
  }
  .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
